<script setup>
import HeaderActions from './HeaderActions.vue';
import { computed } from 'vue';

const props = defineProps({
  avatarUrl: {
    type: String,
    default: '',
  },
  introHeading: {
    type: String,
    default: '',
  },
  introBody: {
    type: String,
    default: '',
  },
  showPopoutButton: {
    type: Boolean,
    default: false,
  },
});

const containerClasses = computed(() => [
  props.avatarUrl ? 'justify-between' : 'justify-end',
]);
</script>

<template>
  <header
    class="header-expanded pt-6 pb-4 px-5 relative box-border w-full bg-transparent"
  >
    <div class="flex items-start" :class="containerClasses">
      <img
        v-if="avatarUrl"
        class="h-12 rounded-full"
        :src="avatarUrl"
        alt="Avatar"
      />
      <HeaderActions
        :show-popout-button="showPopoutButton"
        :show-end-conversation-button="false"
      />
    </div>
    <h2
      v-dompurify-html="introHeading"
      class="mt-4 text-2xl mb-1.5 font-medium text-n-slate-12 intro-heading"
    />
    <p
      v-dompurify-html="introBody"
      class="text-lg leading-normal text-n-slate-11 intro-body"
    />
  </header>
</template>

<style scoped lang="scss">
.intro-heading {
  font-weight: 700;
  color: #fff;
}
.intro-body {
  font-weight: 500;
  color: #fff;
}

.text-base {
  color: #fff !important;
}
.leading-3 {
  color: #fff !important;
}

button {
  svg {
    color: #fff !important;
  }
}
</style>